import React, { useState } from "react";
import PropTypes from "prop-types";
import RadioGroup from "../components/RadioGroup";
import FormSection from "../components/FormSection";
import FormSelect from "../components/FormSelect";
import FormInput from "../components/FormInput";
import backArrow from "../images/Layer 51.svg";
import SignaturePopup from "../components/SignaturePopup";

const ResidencySponsorInfo = ({
  primaryColor = "#1F3047",
  secondaryColor = "#349AC8",
  textColor = "#181818",
  placeholderColor = "#717171",
  onBack = () => {},
  onSubmit = () => {},
  data,
}) => {
  // Form state
  const [formData, setFormData] = useState({
    inFacility: data?.residencySponsor?.inFacility ?? null,
    facilityName: data?.residencySponsor?.facilityName ?? "",
    entryDate: data?.residencySponsor?.entryDate ?? "",
    dischargeDate: data?.residencySponsor?.dischargeDate ?? "",
    residences: data?.residencySponsor?.residences?.map((residence) => ({
      location: residence?.location ?? "",
      dateRange: residence?.dateRange ?? "",
      length: residence?.length ?? "",
      responsibleParty: residence?.responsibleParty ?? "",
    })) ?? [
      {
        location: "",
        dateRange: "",
        length: "",
        responsibleParty: "",
      },
    ],
    sponsorName: data?.residencySponsor?.sponsorName ?? "",
    sponsorPhone: data?.residencySponsor?.sponsorPhone ?? "",
    sponsorRelationship: data?.residencySponsor?.sponsorRelationship ?? "",
    hasPermission: data?.residencySponsor?.hasPermission ?? null,
    felonyConviction: data?.residencySponsor?.felonyConviction ?? null,
    sexOffense: data?.residencySponsor?.sexOffense ?? null,
    onProbation: data?.residencySponsor?.onProbation ?? null,
    disclosePresence: data?.residencySponsor?.disclosePresence ?? false,
    discloseMedicalHistory:
      data?.residencySponsor?.discloseMedicalHistory ?? false,
    discloseProgress: data?.residencySponsor?.discloseProgress ?? false,
    discloseAssessment: data?.residencySponsor?.discloseAssessment ?? false,
    discloseAftercare: data?.residencySponsor?.discloseAftercare ?? false,
    discloseDischarge: data?.residencySponsor?.discloseDischarge ?? false,

    // Obtain fields
    obtainTreatmentPlans: data?.residencySponsor?.obtainTreatmentPlans ?? false,
    obtainLabResults: data?.residencySponsor?.obtainLabResults ?? false,
    obtainPsychAssessment:
      data?.residencySponsor?.obtainPsychAssessment ?? false,
    obtainDischargeSummary:
      data?.residencySponsor?.obtainDischargeSummary ?? false,
    obtainEmploymentInfo: data?.residencySponsor?.obtainEmploymentInfo ?? false,

    // Communication methods
    commElectronic: data?.residencySponsor?.commElectronic ?? false,
    commOral: data?.residencySponsor?.commOral ?? false,
    commWritten: data?.residencySponsor?.commWritten ?? false,

    // Other information
    otherInfoChecked: data?.residencySponsor?.otherInfoChecked ?? false,
    otherInfoDetails: data?.residencySponsor?.otherInfoDetails ?? "",
    reasonContinuity: data?.residencySponsor?.reasonContinuity ?? false,
    reasonHistory: data?.residencySponsor?.reasonHistory ?? false,
    reasonEmergency: data?.residencySponsor?.reasonEmergency ?? false,
    reasonCourtLegal: data?.residencySponsor?.reasonCourtLegal ?? false,
    reasonEmployment: data?.residencySponsor?.reasonEmployment ?? false,
    reasonOtherChecked: data?.residencySponsor?.reasonOtherChecked ?? false,
    reasonOtherDetails: "",
  });

  const [showSignaturePopup, setShowSignaturePopup] = useState(false);
  const [signatureText, setSignatureText] = useState("Patient Signature");
  const [signatureData, setSignatureData] = useState(null);
  const [staffSignatureData, setStaffSignatureData] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleResidenceChange = (index, e) => {
    const { name, value } = e.target;
    setFormData((prev) => {
      const updatedResidences = [...prev.residences];
      updatedResidences[index][name] = value;
      return { ...prev, residences: updatedResidences };
    });
  };

  const addResidence = () => {
    setFormData((prev) => ({
      ...prev,
      residences: [
        ...prev.residences,
        {
          location: "",
          dateRange: "",
          length: "",
          responsibleParty: "",
        },
      ],
    }));
  };

  const handleStoredItemChange = (field) => {
    setFormData((prev) => ({
      ...prev,
      [field]: !prev[field], // Updates root-level field
    }));
  };

  const handleRadioChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Call the onSubmit prop with the complete form data
    onSubmit(formData);
  };

  // const handleClientSignature = () => {
  //   console.log("Signature confirmed");
  //   setSignatureText("Client Signature");
  //   setShowSignaturePopup(true);
  // };

  // const handleClearSignature = () => {
  //   console.log("Signature cleared");
  // };

  // const handleConfirmSignature = (sigData) => {
  //   console.log("Signature confirmed");
  //   setShowSignaturePopup(false);
  //   if (signatureText === "Client Signature") {
  //     setSignatureData(sigData);
  //     window.localStorage.setItem("signatureData", sigData);
  //   } else {
  //     setStaffSignatureData(sigData);
  //     window.localStorage.setItem("staffSignatureData", sigData);
  //   }
  //   console.log("signatureData", signatureData);
  // };

  return (
    <form onSubmit={handleSubmit} style={{ width: "100%" }}>
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "center",
          gap: "48px",
          padding: "20px",
          maxWidth: "1200px",
          margin: "0 auto",
        }}
      >
        {/* Main Title */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "center",
            gap: "16px",
          }}
        >
          <h1
            style={{
              textAlign: "center",
              color: primaryColor,
              fontSize: "32px",
              fontFamily: "Mauren, sans-serif",
              fontWeight: "100",
              margin: 0,
            }}
          >
            Residency & Sponsor Info
          </h1>
          <div style={{ width: "100%", textAlign: "center" }}>
            <span
              style={{
                color: primaryColor,
                fontSize: "16px",
                fontFamily: "'FONTSPRING DEMO - Commuters Sans', sans-serif",
                fontWeight: "400",
                lineHeight: "24px",
              }}
            >
              This part of the intake process is to be completed by{" "}
            </span>
            <span
              style={{
                color: secondaryColor,
                fontSize: "16px",
                fontFamily: "'FONTSPRING DEMO - Commuters Sans', sans-serif",
                fontWeight: "700",
                lineHeight: "24px",
              }}
            >
              you
            </span>
            <span
              style={{
                color: primaryColor,
                fontSize: "16px",
                fontFamily: "'FONTSPRING DEMO - Commuters Sans', sans-serif",
                fontWeight: "400",
                lineHeight: "24px",
              }}
            >
              . If you need any help, a team member is available to assist.
            </span>
          </div>
        </div>

        {/* Form Sections */}
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            gap: "32px",
          }}
        >
          {/* Current Living Situation Section */}
          <FormSection
            title="Current Living Situation"
            primaryColor={primaryColor}
            secondaryColor={secondaryColor}
          >
            <div style={formRowStyle}>
              <RadioGroup
                label="Are you currently residing in a rehab or medical facility?"
                name="inFacility"
                value={formData.inFacility}
                options={["Yes", "No"]}
                onChange={(value) =>
                  handleRadioChange("inFacility", value === "Yes")
                }
                color={primaryColor}
                textColor={textColor}
                fullWidth
              />
              {formData.inFacility && (
                <FormInput
                  label="If yes, please provide the name of the facility"
                  name="facilityName"
                  value={formData.facilityName}
                  onChange={handleChange}
                  placeholder="Ex: Sunrise Recovery Center"
                  color={secondaryColor}
                  textColor={textColor}
                  placeholderColor={placeholderColor}
                />
              )}
            </div>

            {formData.inFacility && (
              <div style={formRowStyle}>
                <FormInput
                  label="Date of entry"
                  name="entryDate"
                  value={formData.entryDate}
                  onChange={handleChange}
                  placeholder="MM/DD/YYYY"
                  color={secondaryColor}
                  textColor={textColor}
                  placeholderColor={placeholderColor}
                />
                <FormInput
                  label="Expected discharge date (if known)"
                  name="dischargeDate"
                  value={formData.dischargeDate}
                  onChange={handleChange}
                  placeholder="MM/DD/YYYY"
                  color={secondaryColor}
                  textColor={textColor}
                  placeholderColor={placeholderColor}
                />
              </div>
            )}
          </FormSection>

          {/* Housing History Section */}
          <FormSection
            title="Housing History"
            primaryColor={primaryColor}
            secondaryColor={secondaryColor}
          >
            {formData.residences.map((residence, index) => (
              <React.Fragment key={index}>
                <div style={formRowStyle}>
                  <FormInput
                    label="Residence Location"
                    name="location"
                    value={residence.location}
                    onChange={(e) => handleResidenceChange(index, e)}
                    placeholder="Ex: 456 Oak Lane, Tampa FL"
                    color={secondaryColor}
                    textColor={textColor}
                    placeholderColor={placeholderColor}
                  />
                  <FormInput
                    label="Date of Stay"
                    name="dateRange"
                    value={residence.dateRange}
                    onChange={(e) => handleResidenceChange(index, e)}
                    placeholder="MM/YYYY - MM/YYYY"
                    color={secondaryColor}
                    textColor={textColor}
                    placeholderColor={placeholderColor}
                  />
                </div>
                <div style={formRowStyle}>
                  <FormInput
                    label="Length of Stay"
                    name="length"
                    value={residence.length}
                    onChange={(e) => handleResidenceChange(index, e)}
                    placeholder="Ex: 3 Months"
                    color={secondaryColor}
                    textColor={textColor}
                    placeholderColor={placeholderColor}
                  />
                  <FormInput
                    label="Responsible Party"
                    name="responsibleParty"
                    value={residence.responsibleParty}
                    onChange={(e) => handleResidenceChange(index, e)}
                    placeholder="Ex: Self, Parent, Roommate"
                    color={secondaryColor}
                    textColor={textColor}
                    placeholderColor={placeholderColor}
                  />
                </div>
                {index < formData.residences.length - 1 && (
                  <div style={dividerStyle} />
                )}
              </React.Fragment>
            ))}

            <button
              type="button"
              onClick={addResidence}
              style={{
                padding: "12px 16px",
                background: secondaryColor,
                borderRadius: "16px",
                border: "none",
                color: "white",
                fontSize: "16px",
                fontFamily: "'FONTSPRING DEMO - Commuters Sans', sans-serif",
                fontWeight: "400",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: "10px",
                alignSelf: "flex-start",
              }}
            >
              <div
                style={{
                  width: "24px",
                  height: "24px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  position: "relative",
                  borderRadius: "50%",
                  border: "2px solid white",
                }}
              >
                <div
                  style={{
                    width: "12px",
                    height: "2px",
                    background: "white",
                    position: "absolute",
                  }}
                />
                <div
                  style={{
                    width: "2px",
                    height: "12px",
                    background: "white",
                    position: "absolute",
                  }}
                />
              </div>
              Add Another Residence
            </button>
          </FormSection>

          {/* Sponsor or Legal Guardian Info Section */}
          <FormSection
            title="Sponsor or Legal Guardian Info"
            primaryColor={primaryColor}
            secondaryColor={secondaryColor}
          >
            <div style={formRowStyle}>
              <FormInput
                label="Sponsor / Legal Guardian Name"
                name="sponsorName"
                value={formData.sponsorName}
                onChange={handleChange}
                placeholder="Ex: John Doe"
                color={secondaryColor}
                textColor={textColor}
                placeholderColor={placeholderColor}
              />
              <FormInput
                label="Phone Number"
                name="sponsorPhone"
                value={formData.sponsorPhone}
                onChange={handleChange}
                placeholder="(XXX) XXX-XXXX"
                color={secondaryColor}
                textColor={textColor}
                placeholderColor={placeholderColor}
              />
            </div>
            <div style={formRowStyle}>
              <FormSelect
                label="Relationship"
                name="sponsorRelationship"
                value={formData.sponsorRelationship}
                onChange={handleChange}
                placeholder="Parent, Spouse, Friend, Other"
                color={secondaryColor}
                textColor={textColor}
                placeholderColor={placeholderColor}
                options={[
                  "Parent",
                  "Spouse",
                  "Sibling",
                  "Friend",
                  "Employer",
                  "Relative",
                  "Guardian",
                  "Other",
                ]}
              />
              <RadioGroup
                label="Do they have permission to discuss your care with us?"
                name="hasPermission"
                value={formData.hasPermission}
                options={["Yes", "No"]}
                onChange={(value) =>
                  handleRadioChange("hasPermission", value === "Yes")
                }
                color={primaryColor}
                textColor={textColor}
              />
            </div>
          </FormSection>

          {/* Legal Background Screening Section */}
          <FormSection
            title="Legal Background Screening"
            primaryColor={primaryColor}
            secondaryColor={secondaryColor}
          >
            <div
              style={{
                ...formRowStyle,
                alignItems: "flex-start",
              }}
            >
              <RadioGroup
                label="Have you been convicted of a felony?"
                name="felonyConviction"
                value={formData.felonyConviction}
                options={["Yes", "No"]}
                onChange={(value) =>
                  handleRadioChange("felonyConviction", value === "Yes")
                }
                color={primaryColor}
                textColor={textColor}
                fullWidth
              />
              <RadioGroup
                label="Have you been convicted of a sex offense?"
                name="sexOffense"
                value={formData.sexOffense}
                options={["Yes", "No"]}
                onChange={(value) =>
                  handleRadioChange("sexOffense", value === "Yes")
                }
                color={primaryColor}
                textColor={textColor}
                fullWidth
              />
              <RadioGroup
                label="Are you currently on probation or parole?"
                name="onProbation"
                value={formData.onProbation}
                options={["Yes", "No"]}
                onChange={(value) =>
                  handleRadioChange("onProbation", value === "Yes")
                }
                color={primaryColor}
                textColor={textColor}
                fullWidth
              />
            </div>
          </FormSection>

          <FormSection
            title="Confidentiality Release Authorization"
            primaryColor={primaryColor}
            secondaryColor={secondaryColor}
          >
            <div
              style={{
                ...formRowStyle,
                alignItems: "flex-start",
                flexDirection: "column",
                gap: "24px",
              }}
            >
              <div style={{ color: textColor, marginBottom: "8px" }}>
                The following information:
              </div>

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "16px",
                  width: "100%",
                }}
              >
                {/* Left Column - Disclose To */}
                <div>
                  <CheckboxItem
                    label="Presence in treatment"
                    checked={formData.disclosePresence}
                    onChange={() => handleStoredItemChange("disclosePresence")}
                    color={primaryColor}
                    textColor={textColor}
                  />
                  <CheckboxItem
                    label="Medical history/current status"
                    checked={formData.discloseMedicalHistory}
                    onChange={() =>
                      handleStoredItemChange("discloseMedicalHistory")
                    }
                    color={primaryColor}
                    textColor={textColor}
                  />
                  <CheckboxItem
                    label="Progress in treatment"
                    checked={formData.discloseProgress}
                    onChange={() => handleStoredItemChange("discloseProgress")}
                    color={primaryColor}
                    textColor={textColor}
                  />
                  <CheckboxItem
                    label="Biopsychosocial assessment"
                    checked={formData.discloseAssessment}
                    onChange={() =>
                      handleStoredItemChange("discloseAssessment")
                    }
                    color={primaryColor}
                    textColor={textColor}
                  />
                  <CheckboxItem
                    label="Aftercare recommendations"
                    checked={formData.discloseAftercare}
                    onChange={() => handleStoredItemChange("discloseAftercare")}
                    color={primaryColor}
                    textColor={textColor}
                  />
                  <CheckboxItem
                    label="Discharge planning"
                    checked={formData.discloseDischarge}
                    onChange={() => handleStoredItemChange("discloseDischarge")}
                    color={primaryColor}
                    textColor={textColor}
                  />
                </div>

                {/* Right Column - Obtain From */}
                <div>
                  <CheckboxItem
                    label="Treatment plans"
                    checked={formData.obtainTreatmentPlans}
                    onChange={() =>
                      handleStoredItemChange("obtainTreatmentPlans")
                    }
                    color={primaryColor}
                    textColor={textColor}
                  />
                  <CheckboxItem
                    label="Laboratory test results"
                    checked={formData.obtainLabResults}
                    onChange={() => handleStoredItemChange("obtainLabResults")}
                    color={primaryColor}
                    textColor={textColor}
                  />
                  <CheckboxItem
                    label="Psychological assessment"
                    checked={formData.obtainPsychAssessment}
                    onChange={() =>
                      handleStoredItemChange("obtainPsychAssessment")
                    }
                    color={primaryColor}
                    textColor={textColor}
                  />
                  <CheckboxItem
                    label="Discharge summary"
                    checked={formData.obtainDischargeSummary}
                    onChange={() =>
                      handleStoredItemChange("obtainDischargeSummary")
                    }
                    color={primaryColor}
                    textColor={textColor}
                  />
                  <CheckboxItem
                    label="Employment information"
                    checked={formData.obtainEmploymentInfo}
                    onChange={() =>
                      handleStoredItemChange("obtainEmploymentInfo")
                    }
                    color={primaryColor}
                    textColor={textColor}
                  />
                </div>
              </div>

              {/* Communication Methods */}
              <div style={{ marginTop: "16px" }}>
                <div style={{ color: textColor, marginBottom: "8px" }}>
                  Communication methods:
                </div>
                <div style={{ display: "flex", gap: "24px" }}>
                  <CheckboxItem
                    label="Electronic"
                    checked={formData.commElectronic}
                    onChange={() => handleStoredItemChange("commElectronic")}
                    color={primaryColor}
                    textColor={textColor}
                  />
                  <CheckboxItem
                    label="Oral"
                    checked={formData.commOral}
                    onChange={() => handleStoredItemChange("commOral")}
                    color={primaryColor}
                    textColor={textColor}
                  />
                  <CheckboxItem
                    label="Written"
                    checked={formData.commWritten}
                    onChange={() => handleStoredItemChange("commWritten")}
                    color={primaryColor}
                    textColor={textColor}
                  />
                </div>
              </div>

              {/* Additional Information */}
              <div style={{ marginTop: "16px", width: "100%" }}>
                <CheckboxItem
                  label="Other:"
                  checked={formData.otherInfoChecked}
                  onChange={() => handleStoredItemChange("otherInfoChecked")}
                  color={primaryColor}
                  textColor={textColor}
                />
                {formData.otherInfoChecked && (
                  <FormInput
                    value={formData.otherInfoDetails}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        otherInfoDetails: e.target.value,
                      }))
                    }
                    placeholder="Please specify"
                    color={secondaryColor}
                    textColor={textColor}
                    placeholderColor={placeholderColor}
                    style={{ marginTop: "8px", width: "100%" }}
                  />
                )}
              </div>
              <div style={{ marginTop: "24px" }}>
                <h3 style={{ color: primaryColor, marginBottom: "16px" }}>
                  Reason for release of information:
                </h3>
                <p
                  style={{
                    fontSize: "14px",
                    color: textColor,
                    marginBottom: "16px",
                    fontStyle: "italic",
                  }}
                >
                  (Under the Mental Health Code, release of mental health
                  records must be germane to the purpose and need for
                  disclosure.)
                </p>

                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: "16px",
                  }}
                >
                  {/* Left Column */}
                  <div>
                    <CheckboxItem
                      label="Continuity of treatment"
                      checked={formData.reasonContinuity}
                      onChange={() =>
                        handleStoredItemChange("reasonContinuity")
                      }
                      color={primaryColor}
                      textColor={textColor}
                    />
                    <CheckboxItem
                      label="Patient history - Case Management services"
                      checked={formData.reasonHistory}
                      onChange={() => handleStoredItemChange("reasonHistory")}
                      color={primaryColor}
                      textColor={textColor}
                    />
                    <CheckboxItem
                      label="Emergency contact - General Updates"
                      checked={formData.reasonEmergency}
                      onChange={() => handleStoredItemChange("reasonEmergency")}
                      color={primaryColor}
                      textColor={textColor}
                    />
                  </div>

                  {/* Right Column */}
                  <div>
                    <CheckboxItem
                      label="Court services - Legal purposes"
                      checked={formData.reasonCourtLegal}
                      onChange={() =>
                        handleStoredItemChange("reasonCourtLegal")
                      }
                      color={primaryColor}
                      textColor={textColor}
                    />
                    <CheckboxItem
                      label="Employment continuity"
                      checked={formData.reasonEmployment}
                      onChange={() =>
                        handleStoredItemChange("reasonEmployment")
                      }
                      color={primaryColor}
                      textColor={textColor}
                    />
                  </div>
                </div>

                {/* Other Option with Text Input */}
                <div style={{ marginTop: "16px" }}>
                  <CheckboxItem
                    label="Other:"
                    checked={formData.reasonOtherChecked}
                    onChange={() =>
                      handleStoredItemChange("reasonOtherChecked")
                    }
                    color={primaryColor}
                    textColor={textColor}
                  />
                  {formData.reasonOtherChecked && (
                    <FormInput
                      value={formData.reasonOtherDetails}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          reasonOtherDetails: e.target.value,
                        }))
                      }
                      placeholder="Please specify reason"
                      color={secondaryColor}
                      textColor={textColor}
                      placeholderColor={placeholderColor}
                      style={{ marginTop: "8px", width: "100%" }}
                    />
                  )}
                </div>
              </div>
            </div>
          </FormSection>
        </div>

        {/* <div
          style={{
            flex: "1 1 0",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            gap: "16px",
          }}
        >
          <div
            style={{
              alignSelf: "stretch",
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: "flex-start",
              gap: "8px",
            }}
          >
            <div
              style={{
                alignSelf: "stretch",
                color: textColor,
                fontSize: "12px",
                fontFamily: "'FONTSPRING DEMO - Commuters Sans', sans-serif",
                fontWeight: "400",
              }}
            >
              Client Signature
            </div>
            <div
              style={{
                alignSelf: "stretch",
                height: "150px",
                background: "white",
                borderRadius: "8px",
                outline: `1px ${secondaryColor} solid`,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "10px",
              }}
              onClick={() => handleClientSignature()}
            >
              {signatureData ? (
                <img
                  src={signatureData}
                  alt="Client Signature"
                  style={{ maxWidth: "100%", maxHeight: "100%" }}
                />
              ) : (
                <div
                  style={{
                    justifyContent: "center",
                    display: "flex",
                    flexDirection: "column",
                    color: "rgba(112.62, 112.62, 112.62, 0.50)",
                    fontSize: "48px",
                    fontFamily: "Turbinado Pro, sans-serif",
                    fontWeight: "400",
                    lineHeight: "24px",
                  }}
                >
                  Client Signature
                </div>
              )}
            </div>
          </div>
        </div>

        {showSignaturePopup && (
          <SignaturePopup
            clientSignatureText={signatureText}
            onClose={() => setShowSignaturePopup(false)}
            onClear={handleClearSignature}
            onConfirm={handleConfirmSignature}
          />
        )} */}

        {/* Form Buttons */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "24px",
            width: "100%",
            marginTop: "20px",
          }}
        >
          <button
            onClick={onBack}
            style={{
              padding: "12px 16px",
              borderRadius: "16px",
              outline: `1px solid ${secondaryColor}`,
              border: "none",
              background: "transparent",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              cursor: "pointer",
            }}
          >
            <div
              style={{
                width: "24px",
                height: "24px",
                padding: "6px",
                background: secondaryColor,
                borderRadius: "50%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img src={backArrow} alt="" />
            </div>
            <span
              style={{
                color: primaryColor,
                fontSize: "16px",
                fontFamily: "'FONTSPRING DEMO - Commuters Sans', sans-serif",
                fontWeight: "400",
              }}
            >
              Back to Contact Info
            </span>
          </button>

          <button
            onClick={() => onSubmit(formData)}
            style={{
              padding: "12px 16px",
              background: secondaryColor,
              borderRadius: "16px",
              border: "none",
              color: "white",
              fontSize: "16px",
              fontFamily: "'FONTSPRING DEMO - Commuters Sans', sans-serif",
              fontWeight: "400",
              cursor: "pointer",
            }}
          >
            Continue to Health Info
          </button>
        </div>
      </div>
    </form>
  );
};

const formRowStyle = {
  display: "flex",
  gap: "24px",
  width: "100%",
};

const dividerStyle = {
  height: "1px",
  width: "100%",
  background: "#e0e0e0",
  margin: "16px 0",
};

// PropTypes
ResidencySponsorInfo.propTypes = {
  primaryColor: PropTypes.string,
  secondaryColor: PropTypes.string,
  textColor: PropTypes.string,
  placeholderColor: PropTypes.string,
  onBack: PropTypes.func,
  onSubmit: PropTypes.func,
};

export default ResidencySponsorInfo;

const CheckboxItem = ({ label, checked, onChange, color, textColor }) => (
  <div
    style={{
      padding: "8px 0",
      display: "flex",
      alignItems: "center",
      gap: "16px",
      cursor: "pointer",
    }}
    onClick={onChange}
  >
    <div
      style={{
        width: "24px",
        height: "24px",
        padding: "2px",
        position: "relative",
        overflow: "hidden",
        borderRadius: "4px",
        outline: `1px solid ${color}`,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: checked ? color : "transparent",
      }}
    >
      {checked && (
        <div
          style={{
            width: "15px",
            height: "10px",
            borderBottom: "2px solid white",
            borderLeft: "2px solid white",
            transform: "rotate(-45deg)",
            marginBottom: "2px",
          }}
        />
      )}
    </div>
    <span
      style={{
        textAlign: "center",
        color: textColor,
        fontSize: "16px",
        fontFamily: "'FONTSPRING DEMO - Commuters Sans', sans-serif",
        fontWeight: "400",
        lineHeight: "24px",
      }}
    >
      {label}
    </span>
  </div>
);
